import React from 'react'
import styles from './rangeInputs.module.scss'
import i18n from 'constants/strings'
import { ClassNamesProps } from 'types/utilities'
import cx from 'classnames'
import Separator from 'components/generic/Separator'

type ClassKeys = 'inputsContainer' | 'inputGroup' | 'input' | 'label'

interface Props extends ClassNamesProps<ClassKeys> {
  id: string
  min: number | null
  max: number | null
  inputError: string | null
  handleMinInputChange: (event: any) => void
  handleMaxInputChange: (event: any) => void
  onBlur?: () => void
  disabled?: boolean
}

const RangeInputs = ({
  id,
  min,
  max,
  inputError,
  handleMaxInputChange,
  handleMinInputChange,
  onBlur,
  classNames,
  disabled = false,
}: Props) => {
  return (
    <>
      <div className={cx(styles.rangeFilterInputsWrapper, classNames?.inputsContainer)}>
        <div className={cx(styles.rangeFilterInputWrapper, classNames?.inputGroup)}>
          <label className={cx(styles.label, classNames?.label)} htmlFor={`inputRangeMin-${id}`}>
            {i18n.t('strFilterBar.minRating')}
          </label>
          <input
            value={max ?? ''}
            onChange={handleMaxInputChange}
            type='number'
            step={0.1}
            onBlur={onBlur}
            className={cx(styles.input, classNames?.input)}
            id={`inputRangeMin-${id}`}
            disabled={disabled}
          />
        </div>
        <Separator className={styles.rangeFilterInputsDivider} />
        <div className={cx(styles.rangeFilterInputWrapper, classNames?.inputGroup)}>
          <label className={cx(styles.label, classNames?.label)} htmlFor={`inputRangeMax-${id}`}>
            {i18n.t('strFilterBar.maxRating')}
          </label>
          <input
            value={min ?? ''}
            onChange={handleMinInputChange}
            type='number'
            step={0.1}
            onBlur={onBlur}
            className={cx(styles.input, classNames?.input)}
            id={`inputRangeMax-${id}`}
            disabled={disabled}
          />
        </div>
      </div>
      {inputError && (
        <p role='alert' className={styles.error}>
          {inputError}
        </p>
      )}
    </>
  )
}

export default RangeInputs
